import React from 'react';
import clsx from 'clsx';
import styles from './DashboardRow.module.css';

export interface DashboardRowProps {
  children: React.ReactNode;
  variant?: 'default' | '2col';
  className?: string;
}

const DashboardRow: React.FC<DashboardRowProps> = ({ children, variant = 'default', className }) => {
  return <div className={clsx(styles.row, variant === '2col' && styles.row2col, className)}>{children}</div>;
};

export default DashboardRow;
